import { Box, Container, Stack, useStyleConfig } from "@chakra-ui/react";
import ContentParse from "../../components/ContentParser";
import Image from "next/image";
import { wpStyles } from "../../theme/wp-styles";

const HeroBanner = ({ content, image }) => {
  const buttonStyles = useStyleConfig("Button", {
    size: "lg",
  });
  console.log("hero image", image);
  return (
    <Box bg={wpStyles.colors.primary} color="white" overflow="hidden">
      <Container variant="no-mobile-p">
        <Stack
          direction={{ base: "column", md: "row" }}
          align="center"
          spacing={0}
        >
          {content && (
            <Box
              w={{ base: "100%", md: "50%" }}
              py={{ base: 8, md: 4 }}
              order={{ base: 2, md: 1 }}
              sx={{
                p: {
                  my: 12,
                  _last: {
                    mb: 0,
                  },
                },
                a: {
                  ...buttonStyles,
                  px: 12,
                  textTransform: "uppercase",
                },
                h2: {
                  fontSize: wpStyles.fontSize.gigantic,
                  fontWeight: "bold",
                },
              }}
            >
              <ContentParse content={content} />
            </Box>
          )}
          {image && (
            <Box
              w={{ base: "100%", md: "50%" }}
              position="relative"
              style={{
                maxHeight: "calc(100vh - 300px)",
              }}
              h={{ base: "auto", md: "600px" }}
              order={{ base: 1, md: 2 }}
              sx={{
                "> span": {
                  w: "100%",
                  display: "block!important",
                  minW: { base: "100%", md: `${image.width}px` },
                  minH: { base: "100%", md: `${image.height}px!important` },
                },
                img: {
                  maxW: { base: "100%", md: "1440px" },
                  position: { base: "relative", md: "absolute" },
                  left: 0,
                  top: 0,
                  objectFit: "cover",
                },
              }}
            >
              <img
                src={image?.url}
                width={`${image.width}px`}
                height={`${image.height}px`}
                alt={image?.alt}
              />
            </Box>
          )}
        </Stack>
      </Container>
    </Box>
  );
};

export default HeroBanner;
